
<template>
  <div>
    <Card v-if="!nextLoading">
      <div class="number_pointNew" v-show="form.applicationNo">流水号：<span>{{form.applicationNo}}</span></div>
      <Collapse v-model="value">
        <!-- <Panel name="0" v-if="form.prequalificationFeedBackList&&form.prequalificationFeedBackList.length>0">
          补交材料要求
          <template #content>
            <div>
              <Alert type="warning">
                <div v-for="(prequalificationFeedBack,index) in form.prequalificationFeedBackList" class="logrem" :key="index">
                  <strong>{{prequalificationFeedBack.title}}</strong>
                  <div>{{prequalificationFeedBack.val}}</div>
                </div>
              </Alert>
            </div>
          </template>
        </Panel> -->
        <Panel name="1">
          单位信息
          <template #content>
            <unit-detail :form="form" @handlePreview="handlePreview" :enterpriseAgentList="enterpriseAgentList"></unit-detail>
          </template>
        </Panel>
        <Panel name="2">
          申请人信息
          <template #content>
            <basic-detail :form="form" @handleView="handleView" @handlePreview="handlePreview"></basic-detail>
          </template>
        </Panel>
        <Panel name="3" v-if="form.isSpouseEnjoyTreatment===true">
          同住配偶信息
          <template #content>
            <spouse-detail :form="form" @handleView="handleView" @handlePreview="handlePreview"></spouse-detail>
          </template>
        </Panel>
        <Panel name="4" v-if="form.isChildrenEnjoyTreatment===true">
          同住子女信息
          <template #content>
            <child-detail :form="form" @handleView="handleView" @handlePreview="handlePreview"></child-detail>
          </template>
        </Panel>

      </Collapse>
      <!-- <unit-detail :form="form" :enterpriseAgentList="enterpriseAgentList"></unit-detail> -->
      <!-- <basic-detail :form="form" @handleView="handleView"></basic-detail> -->
      <!-- <spouse-detail :form="form" @handleView="handleView"></spouse-detail> -->
      <!-- <child-detail :form="form" @handleView="handleView"></child-detail> -->

    </Card>
    <Spin size="large" fix v-if="nextLoading"></Spin>

  </div>
</template>
<script>
import '../styles/points.less'
import UnitDetail from './modules/unitDetail/index'
import BasicDetail from './modules/basicDetail/index'
import SpouseDetail from './modules/spouseDetail/index.vue'
import ChildDetail from './modules/childDetail/index.vue'

export default {
  components: {
    UnitDetail,
    BasicDetail,
    SpouseDetail,
    ChildDetail,
  },
  data() {
    return {
      value: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      form: {}, //当前数据
      currentGuid: '', //当前数据guid
      appInfoDataType: this.$store.state.appInfoDataType, //查询数据状态
      nextLoading: false, //页面加载效果
      enterpriseAgentList: [], //经办人列表
    }
  },
  mounted() {
    this.currentGuid = this.$route.query.guid
    this.getFullInfo(this.currentGuid, this.appInfoDataType['全部'])
  },
  methods: {
    //获取全部信息
    async getFullInfo(guid, loadAppInfoTypes) {
      this.nextLoading = true
      try {
        const { data } = await this.$Ajax.get(`/api/services/app/TJTZRApi/GetAppFullInfo`, {
          params: { guid, loadAppInfoTypes },
        })
        //数据处理
        if (!data.result.personalInfoChange) {
          data.result.personalInfoChang = {}
        }
        //赋值
        this.form = {
          // ...data.result.spouse,
          childrenList: data.result.childrenList,
          ...data.result.mainInfo,
          ...data.result.spouse,
          ...data.result.education,
          ...data.result.personalInfoChange,
          plusInvestmentTaxationDrivingLocalEmploymentList:
            data.result.plusInvestmentTaxationDrivingLocalEmploymentList,
          plusIncubatorMaterialList: data.result.plusIncubatorMaterialList,
          plusRecognitionAwardList: data.result.plusRecognitionAwardList,
          plusSkillLevelList: data.result.plusSkillLevelList,
          plusTitleList: data.result.plusTitleList,
          spouseList: data.result.spouseList,
          juniorCollegeEducation: data.result.juniorCollegeEducation,
          prequalificationFeedBackList: data.result.prequalificationFeedBackList,
        }

        this.currentGuid = this.form.guid
        /* 
        时间处理
         */
        if (this.form.applicantResidencePermitExpiryDate) {
          this.form.applicantResidencePermitExpiryDate = new Date(
            this.form.applicantResidencePermitExpiryDate
          )
        }
        if (this.form.enrolDate) {
          this.form.enrolDate = new Date(this.form.enrolDate)
        }
        if (this.form.graduationDate) {
          this.form.graduationDate = new Date(this.form.graduationDate)
        }

        this.enterpriseAgentList = data.result.basicData.enterpriseAgentList
        this.isEnterprise = data.result.basicData.isEnterprise
        this.hasLaborDispatchPermit = data.result.basicData.hasLaborDispatchPermit
        this.$store.commit('setMateriaBasicData', data.result.basicData.enumData)
      } catch (error) {}
      this.nextLoading = false
    },
    //查看图片文件
    handleView(guid) {
      let _this = this

      const $viewer = this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: 0,
        },
        images: [_this.$baseURL + '/file/preview/' + guid],
      })
    },
    //查看文件
    handlePreview(file) {
      if (typeof file !== 'object') {
        //单个图片
        // window.open(this.$baseURL + '/file/preview/' + file)
        const $viewer = this.$viewerApi({
          options: {
            toolbar: true,
            initialViewIndex: 0,
          },
          images: [this.$baseURL + '/file/preview/' + file],
        })
        return
      }
      let _this = this
      if (file.url) {
        let fileExtension
        if (file.name.indexOf('.') >= 0) {
          fileExtension = file.name.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }

        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.url],
          })
          return
        }
        window.open(this.$baseURL + file.url)
        return
      }
      if (file.status == 'finished') {
        let fileExtension
        if (file.url.indexOf('.') >= 0) {
          fileExtension = file.response.result.fileName.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }
        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.response.result.imageUrl],
          })
          return
        }
        window.open(this.$baseURL + file.response.result.imageUrl)
      }
    },
  },
}
</script>
<style scoped>
.logrem {
  white-space: pre-line;
}
</style>